import { Component, Input, Output, EventEmitter, Injector, Type } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '@metromarkets/sdk';

import {
  ACCOUNT_ADDRESS_BOOK_LINK,
  ACCOUNT_INFORMATION_LINK,
  ORDER_HISTORY_LINK,
} from '~shared/constants/links.constants';

import { CHECKOUT_LOCALSTORAGE_KEY } from '~app/modules/checkout/constants';
import { IdentityService } from '~core/modules/identity/services/identity.service';
import { PageService } from '~shared/services/page.service';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import {
  LogoutClickApplicationEvent,
  NavigationApplicationEvent,
  AuthorizationApplicationEvent
} from '~shared/modules/application-event/models';
import {
  ApplicationNavigationEventType,
  ApplicationAuthorizationActionType as AuthType
} from '~shared/modules/application-event/constants';
import { IAccountInformation } from '~shared/models';
import { environment } from '~env/environment';
import { MmPopoverRef } from '~shared/modules/popover/popover.module';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '~app/modules/authorization/services/authorization-idam.service';
import { Subject } from 'rxjs';
import { ShowElementSharedService } from '~app/modules/generic/services/show-element-shared-service';
import { MediaObserver } from '@angular/flex-layout';
import { GaTrackingEventLabel } from '~shared/modules/ga-tracking/constants';
import { MEDIA_ALISES } from '~shared/constants/media.constant';

@Component({
  selector: 'app-account-dropdown',
  templateUrl: './account-dropdown.component.html',
  styleUrls: ['./account-dropdown.component.scss']
})
export class AccountDropdownComponent {
  private unsubscribe$ = new Subject<void>();

  @Input() isMobile: boolean;
  @Input() userData: IAccountInformation;
  @Output() closeSlideMenu: EventEmitter<any> = new EventEmitter<any>();
  avatarIcon = `${environment.cdnBaseUrl()}/images/metrox/icon_avatar.svg`;
  accountPopOverRef;
  isMobileDevice: boolean;

  accountMenu = [
    {
      title: 'CORE.ALL_PAGES.USER_BOX.ORDERS.LABEL',
      link: ORDER_HISTORY_LINK
    }, {
      title: 'CORE.ALL_PAGES.USER_BOX.ACCOUNT_INFO.LABEL',
      link: ACCOUNT_INFORMATION_LINK
    }, {
      title: 'CORE.ALL_PAGES.USER_BOX.ADDRESS_BOOK.LABEL',
      link: ACCOUNT_ADDRESS_BOOK_LINK
    }
  ];
  menuStyles: { [key: string]: string | number };

  constructor(
    private router: Router,
    private pageService: PageService,
    private identityService: IdentityService,
    private storageService: StorageService,
    private applicationEventService: ApplicationEventService,
    private injector: Injector,
    private authService: AuthService,
    private showElementSharedService: ShowElementSharedService,
    private mediaObserver: MediaObserver,
  ) {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobileDevice =
          this.mediaObserver.isActive(MEDIA_ALISES.mobile) ||
          this.mediaObserver.isActive(MEDIA_ALISES.tablet);
      });
  }

  onMenuItemClick(itemLink: string): void {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.NavigationUserAccountMenuClick,
        null,
        itemLink
      )
    );
    this.closeSlideMenu.emit();
  }

  closeMenu() {
    this.closeSlideMenu.emit();
    this.showElementSharedService.showStickyAddToCartOnPdp(true);
  }


  logOut() {
    this.closeSlideMenu.emit();
    if(!this.isMobileDevice) {
      this.accountPopOverRef = this.injector.get<MmPopoverRef>(MmPopoverRef as Type<MmPopoverRef>);
    }
    if (this.accountPopOverRef) {
      this.accountPopOverRef.close();
    }
    const user = this.identityService.getUserInformation();
    this.identityService.unauthorize();
    this.authService.logout();
    this.applicationEventService.publish(
      new AuthorizationApplicationEvent(AuthType.LoggedOut, user.registrationType)
    );

    // TODO: MOVE THIS LOGIC TO CHECKOUT or CART SERVICE
    this.storageService.local.remove(CHECKOUT_LOCALSTORAGE_KEY);
    this.applicationEventService.publish(new LogoutClickApplicationEvent());

    const isCurrentPageAnonymous = this.pageService.isPageAnonymous(this.router.url);
    if (isCurrentPageAnonymous) {
      return;
    }

    const loginUrlTree = this.pageService.getLoginUrlTree();
    this.router.navigateByUrl(loginUrlTree);
  }

  getMenuItemTrackingLabel(menuItemLink: string): string {
    switch (menuItemLink) {
      case ORDER_HISTORY_LINK:
        return GaTrackingEventLabel.UserOrdersPage;
      case ACCOUNT_INFORMATION_LINK:
        return GaTrackingEventLabel.UserAccountInformationPage;
      case ACCOUNT_ADDRESS_BOOK_LINK:
        return GaTrackingEventLabel.UserAddressBookPage;
      default:
        return menuItemLink;
    }
  }
}
